import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the ServiceGvariableProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ServiceGvariableProvider {
  
  constructor(public http: HttpClient) {
    console.log('Hello ServiceGvariableProvider Provider');
    
  }
  public URL = "http://www.rhtyre.com";
  //public URL = "http://test.rhtyre.com/";
  public InternetConnection = "Online";
  public f_lastfleetPay = 0;                    //for reprint function

  // [CXY:14/06/2020:CR/MPOS/20-01]:Added variable WantokGiftCard_URL
  public WantokGiftCard_URL = "https://giftcard.wantokpoints.com";  // Production
  //public WantokGiftCard_URL = "http://tester.wantokpoints.com";   // Development
  //public WantokGiftCard_URL = "http://127.0.0.1/Wantok_GiftCard"; // Localhost
}


// WEBPACK FOOTER //
// ./src/providers/service-gvariable/service-gvariable.ts